import { render, staticRenderFns } from "./MenuGrupo.vue?vue&type=template&id=0e0cbc36&"
import script from "./MenuGrupo.vue?vue&type=script&lang=js&"
export * from "./MenuGrupo.vue?vue&type=script&lang=js&"
import style0 from "./MenuGrupo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports